import React from 'react';
import { Grid } from '@material-ui/core';
import {
  StyledCaptions,
  ItemWrapper,
  ContentWrapper,
  StyledIcon,
  StyledSmallIcon,
} from 'components/MenuItem/styles';
import { AssuranceIcon } from 'images';
import { IntlShape, injectIntl } from 'react-intl';
import { darkBlue } from 'Material-UI/colors';
import { pushTo } from 'helpers/routes';
import { connect } from 'react-redux';
import { getIsOpenAddNewContractModalSelector } from 'store/contract/selectors';

import { createStructuredSelector } from 'reselect';
import AddNewContractModal from 'components/AddNewContractModal';
import ModalServicesAuto from 'components/ModalServices/ModalServicesAuto';
import {
  getIsModalServicesAutoSelector,
  getIsModalServicesMrhSelector,
} from 'store/global/selectors';
import ModalServicesMrh from 'components/ModalServices/ModalServicesMrh';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

type MenuItemType = {
  items: any;
  setDetailsPageBreadcrumbsPath: Function;
  intl: IntlShape;
  openServices: Function;
  isOpen: boolean;
  isOpenModalService: boolean;
  isOpenModalServiceMrh: boolean;
};
const MenuItem = ({
  isOpen,
  isOpenModalService,
  isOpenModalServiceMrh,
  ...props
}: MenuItemType) => {
  return (
    <>
      <Grid spacing={3} container>
        {props.items.map(
          (
            item: {
              path: string;
              icon: string;
              title: string;
              BreadcrumbsPath?: { name: string; path: string }[];
              openModalServices?: Boolean;
              smalIcon?: Boolean;
              category: string;
              label: string;
            },
            index: number,
          ) => (
            <Grid item xs={4} key={index}>
              <GaClickHOC category={item.category} label={item.label}>
                <ItemWrapper
                  data-testid="menu_item"
                  onClick={() => {
                    if (item.BreadcrumbsPath) {
                      props.setDetailsPageBreadcrumbsPath(item.BreadcrumbsPath);
                      pushTo(item.path);
                    } else if (item.openModalServices) {
                      props.openServices();
                    } else {
                      pushTo(item.path);
                    }
                  }}
                >
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </GaClickHOC>
            </Grid>
          ),
        )}
        <AddNewContractModal isOpen={isOpen} />
        <ModalServicesAuto isOpen={isOpenModalService} />
        <ModalServicesMrh isOpen={isOpenModalServiceMrh} />
      </Grid>
    </>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    isOpen: boolean;
    isOpenModalService: boolean;
    isOpenModalServiceMrh: boolean;
  }
>({
  isOpen: getIsOpenAddNewContractModalSelector,
  isOpenModalService: getIsModalServicesAutoSelector,
  isOpenModalServiceMrh: getIsModalServicesMrhSelector,
});

export default connect(mapStateToProps)(injectIntl(MenuItem));
export { MenuItem };
